import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import { jsPDF } from "jspdf";
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import VueDragAndDropList from 'vue-drag-and-drop-list';
import Spinner from 'vue-spinkit'
import VueSweetalert2 from "vue-sweetalert2";
import Swal from "sweetalert2/dist/sweetalert2.js";
import InfiniteSlideBar from 'vue-infinite-slide-bar'
import "sweetalert2/dist/sweetalert2.min.css";
import SequentialEntrance from 'vue-sequential-entrance'
import 'vue-sequential-entrance/vue-sequential-entrance.css'
Vue.use(SequentialEntrance);

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  timer: 10000,
  timerProgressBar: true,
  showConfirmButton: false
});
window.Toast = Toast;
Vue.use(InfiniteSlideBar)
Vue.use(VueSweetalert2);
Vue.use(VueDragAndDropList);
Vue.use(jsPDF)
Vue.use(Spinner)
Vue.component('Spinner', Spinner)
Vue.use(PerfectScrollbar)
Vue.use(VueApexCharts)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
